import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// We'll create these JSON files in the next step
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

i18n
  // Detect user's browser language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // We're passing in the translations manually
    resources: {
      en: {
        translation: enTranslations,
      },
      ar: {
        translation: arTranslations,
      },
    },
    // Default language to use
    fallbackLng: 'en',
    debug: false, // Set to true to see logs in the console
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
  });

export default i18n;